"use client";

import { useTranslations } from "next-intl";
import { usePathname, useRouter } from "next/navigation";

export default function ClearFilters() {
  const router = useRouter();
  const pathname = usePathname() || "";
  const t = useTranslations();

  function handleClear() {
    router.replace(pathname, { scroll: false });
  }

  return (
    <div className="px-5 py-4 bg-white rounded-lg shadow-1">
      <div className="flex items-center justify-between">
        <p>{t("Filters.title")}</p>
        <button className="text-blue" onClick={handleClear}>
          {t("Filters.titleButton")}
        </button>
      </div>
    </div>
  );
}
